import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { obtenerProductosSalidas } from "../redux/actions/index.js"; // Acción que trae los productos
import { Link } from "react-router-dom";
import ProductoDetail from "./ProductoDetail.jsx";

const ProductoList = ({ agregarAlCarrito, carrito }) => {
  const dispatch = useDispatch();
  const [busqueda, setBusqueda] = useState("");

  // Accedemos al estado de productos desde Redux
  const productos = useSelector((state) => state.productosSalidas);
  const cargando = useSelector((state) => state.loading);
  const error = useSelector((state) => state.error);

  // Filtrar los productos según la búsqueda
  const productosFiltrados = productos.filter((producto) => {
    const busquedaLower = busqueda.toLowerCase();
    return (
      producto.nombre.toLowerCase().includes(busquedaLower) ||
      producto.codigoBarras.includes(busquedaLower)
    );
  });

  // Ordenar los productos por stock y alfabéticamente
  const productosOrdenados = [...productosFiltrados].sort((a, b) => {
    // Ordenar por stock en orden descendente
    if (b.stock !== a.stock) {
      return b.stock - a.stock;
    }
    // Si el stock es igual, ordenar alfabéticamente por nombre
    return a.nombre.localeCompare(b.nombre);
  });

  // Al cargar el componente, despachamos la acción para obtener los productos
  useEffect(() => {
    dispatch(obtenerProductosSalidas());
  }, [dispatch]);

  return (
    <div className="h-full">
      <h1 className="flex text-textoClaro justify-center text-4xl font-bold">
        Listado de Productos
      </h1>

      <div className="m-4">
        <input
          type="text"
          className="bg-backgroundClaro border-[#000000] rounded-lg text-textoOscuro placeholder-[#808080] focus:ring-4 focus:ring-green-800 focus:border-green-600 w-[100%] p-2 sm:p-1"
          placeholder="Buscar por nombre o ID"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      {cargando && <p>Cargando productos...</p>}
      {error && <p>Hubo un error: {error}</p>}

      {productosOrdenados?.length === 0 && !cargando && (
        <div>
          <p>
            No hay productos. <Link to="/altaproducto">Crea uno aquí.</Link>
          </p>
        </div>
      )}

      <section className="text-gray-600 body-font">
        <div className="px-5 py-4 mx-auto">
          <div className="flex justify-between -mx-4 text-center">
            {productosOrdenados?.length ? (
              <div className="mx-auto flex w-full flex-col justify-center px-5 pt-0 md:max-w-[95%]">
                <div className="w-full rounded-lg">
                  <div className="rounded-lg border w-full border-zinc-800 sm:overflow-auto">
                    <div className="overflow-x-scroll xl:overflow-x-hidden">
                      <div className="relative w-full overflow-auto">
                        <table className="caption-bottom text-sm w-full">
                          <thead className="[&amp;_tr]:border-b border-b-[1px] border-zinc-200 dark:border-zinc-800">
                            <tr className="dark:border-zinc-800">
                              <th className="border border-zinc-800 text-white p-2">
                                Nombre Producto
                              </th>
                              <th className="border border-zinc-800 text-white p-2">
                                Categoria
                              </th>
                              <th className="border border-zinc-800 text-white p-2">
                                Cantidad
                              </th>
                              <th className="border border-zinc-800 text-white p-2">
                                Stock Actual
                              </th>
                              <th className="border border-zinc-800 text-white p-2">
                                Unidad
                              </th>
                              <th className="border border-zinc-800 text-white p-2"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {productosOrdenados.map((producto) => (
                              <ProductoDetail
                                producto={producto}
                                carrito={carrito}
                                key={producto.id}
                                agregarAlCarrito={agregarAlCarrito}
                              />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductoList;